module.exports = __webpack_public_path__ + "img/01.199bec76.jpg";